import React from "react";

import { useGetApplicationQuery } from "EmployeeApplication/api";
import { MedicalPage } from "EmployeeCoverage/Components/Medical";
import BasicLoading from "ZeroRuby/BasicLoading";

import MissingZipCode from "../components/MissingZipCode";
import Page from "../Page";
import BodyText from "Cobalt/BodyText";
import { CardSection } from "Cobalt/Card";
import { RoutedBackButton } from "Common/forms/buttons";

const NoCoverageOffered = () => (
  <CardSection>
    <BodyText size="large" agent>
      Thanks for inquiring! Your company is still setting up their plan selections. We will be in touch when next steps are available. In the meantime, if you
      have questions - please contact us at <a href="https://get.simplyinsured.com/contact">get.simplyinsured.com/contact</a>.
    </BodyText>
  </CardSection>
);

const useData = () => {
  const { isLoading: isLoadingApplication, data: { employeePolicy: { employeeForm: { zipCode } = {} } = {}, availablePlans = [] } = {} } =
    useGetApplicationQuery();

  return {
    isLoadingApplication,
    offeringMedical: availablePlans.includes("medical"),
    missingZipCode: !zipCode,
  };
};

const PageContent = () => {
  const { isLoadingApplication, missingZipCode, offeringMedical } = useData();

  if (isLoadingApplication) {
    return (
      <CardSection>
        <BasicLoading />
      </CardSection>
    );
  }
  if (missingZipCode) {
    return (
      <CardSection>
        <MissingZipCode />
      </CardSection>
    );
  }
  if (!offeringMedical) {
    return (
      <CardSection>
        <NoCoverageOffered />
      </CardSection>
    );
  }
  return <MedicalPage />;
};

const ChooseMedicalCoveragePage = ({ backLink, onClickBack }) => (
  <Page>
    <PageContent />
    <CardSection>
      <RoutedBackButton href={backLink} onClick={onClickBack} />
    </CardSection>
  </Page>
);

export default ChooseMedicalCoveragePage;
